<div class="form-item error stacked" [formGroup]="formGroup">
  <label [attr.for]="id" [innerText]="fullLabel | async"
         [optional]="formGroup.controls[myformControlName]"></label>
  <div *ngIf="message" class="field-message" [id]="id + '-message'">
    <div [innerHTML]="message"></div>
    <div class="accolade "></div>
  </div>
  <div class="form-columns">
    <div class="form-item-column">
      <input type="date" useValueAsDate
             [id]="id"
             [formControlName]="myformControlName"
             [ngClass]="{'error': error}"
             [attr.aria-describedby]="describedBy"
             [dmv-required]="formGroup.controls[myformControlName]"
             [attr.aria-invalid]="error ? true : null"
             (input)="emitDate($event.target.value)" [min]="min" [max]="max" />
    </div>
    <div class="form-item-column">
      <div *ngIf="error" class="field-message error" role="alert" [id]="id + '-error'">
        <div [innerHTML]="error"></div>
        <div class="accolade"></div>
      </div>
    </div>
  </div>
</div>
